export { default as ViewGridIcon } from './ViewGridIcon';
